import { Button } from '@c2fo/liquidity';
import { AccountMultipleIcon, GlobeAsiaIcon } from '@c2fo/liquidity/icons';
import { useServiceAccountSelector, useDataRegionSelector } from '../../contexts/FileDeliveryContext';
import { LoadingOverlay } from '../LoadingSpinner';

interface RequireServiceAccountProps {
  children: React.ReactNode;
}

export const RequireServiceAccount: React.FC<RequireServiceAccountProps> = ({ children }) => {
  const { serviceAccount, focusSelector, isInitialized: serviceAccountInitialized } = useServiceAccountSelector();
  const { dataRegion, isInitialized: dataRegionInitialized } = useDataRegionSelector();

  const isInitializing = !dataRegionInitialized || !serviceAccountInitialized;

  if (isInitializing) {
    return <LoadingOverlay message="Loading settings..." />;
  }

  const missingDataRegion = !dataRegion;
  const missingServiceAccount = !serviceAccount;

  if (missingDataRegion || missingServiceAccount) {
    return (
      <div className="max-w-4xl mx-auto mt-8">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
          <div className="text-center">
            {missingDataRegion && missingServiceAccount ? (
              <>
                <div className="flex justify-center gap-2 mb-4">
                  <GlobeAsiaIcon className="h-12 w-12 text-gray-400" />
                  <AccountMultipleIcon className="h-12 w-12 text-gray-400" />
                </div>
                <h2 className="text-lg font-medium text-gray-900 mb-2">Configuration Required</h2>
                <p className="text-sm text-gray-500 mb-6">
                  Please select a data region and service account from the dropdowns in the navigation bar to continue.
                </p>
              </>
            ) : missingDataRegion ? (
              <>
                <GlobeAsiaIcon className="h-12 w-12 mx-auto text-gray-400 mb-4" />
                <h2 className="text-lg font-medium text-gray-900 mb-2">No Data Region Selected</h2>
                <p className="text-sm text-gray-500 mb-6">
                  Please select a data region from the dropdown in the navigation bar to continue.
                </p>
              </>
            ) : (
              <>
                <AccountMultipleIcon className="h-12 w-12 mx-auto text-gray-400 mb-4" />
                <h2 className="text-lg font-medium text-gray-900 mb-2">No Service Account Selected</h2>
                <p className="text-sm text-gray-500 mb-6">
                  Please select a service account from the dropdown in the navigation bar to continue.
                </p>
                <Button variant="primary" className="rounded-md text-white" onClick={focusSelector}>
                  Select Service Account
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
